import { render } from "./ProspectView.vue?vue&type=template&id=74e54e14"
import script from "./ProspectView.vue?vue&type=script&lang=js"
export * from "./ProspectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__